import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caf75ffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_7 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_8 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-6"
}
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "N.Identificação"
}, "N.Identificação", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_23 = { class: "ant-row" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_tipo_movimento_financeiro = _resolveComponent("selecionar-tipo-movimento-financeiro")!
  const _component_selecionar_tipo_documento_financeiro = _resolveComponent("selecionar-tipo-documento-financeiro")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_marcador_movimento_financeiro = _resolveComponent("selecionar-marcador-movimento-financeiro")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_movimento_financeiro_centro_custo = _resolveComponent("movimento-financeiro-centro-custo")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_movimento_financeiro_anexo = _resolveComponent("movimento-financeiro-anexo")!
  const _component_movimento_financeiro_titulos_baixados = _resolveComponent("movimento-financeiro-titulos-baixados")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: _ctx.state.tituloModal,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 1000,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'full-modal ss-modal-financeiro':'ss-modal-financeiro',
    maskClosable: false
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.state.editavel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.state.modoPrePreenchido)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_a_form_item, {
                        label: "Empresa",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_empresa, {
                            codigoSelecionado: _ctx.state.movimento.codigoEmpresa,
                            "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.movimento.codigoEmpresa) = $event)),
                            empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                            disabled: true
                          }, null, 8, ["codigoSelecionado", "empresasEspecificas"])
                        ]),
                        _: 1
                      })
                    ])
                  ], 512), [
                    [_vShow, _ctx.telaBase.apresentarEmpresas]
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_selecionar_conta, {
                        codigoSelecionado: _ctx.state.movimento.codigoConta,
                        "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.movimento.codigoConta) = $event)),
                        empresas: [_ctx.state.movimento.codigoEmpresa],
                        disabled: true
                      }, null, 8, ["codigoSelecionado", "empresas"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_form_item, {
                        label: "Data",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            horaMinutoSegundo: true,
                            dataSelecionada: _ctx.state.movimento.dataMovimento,
                            "onUpdate:dataSelecionada": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.movimento.dataMovimento) = $event)),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["dataSelecionada", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.props.dataVencimento !== '' && _ctx.props.dataVencimento !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_a_form_item, {
                            label: "Vencimento",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                horaMinutoSegundo: false,
                                dataSelecionada: _ctx.props.dataVencimento,
                                disabled: true
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.UtilitarioGeral.validaCodigo(_ctx.state.movimento.codigo))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Competência",
                            class: "ss-margin-campos",
                            rules: [{ required: true }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                horaMinutoSegundo: false,
                                dataSelecionada: _ctx.state.movimento.dataCompetencia,
                                "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.movimento.dataCompetencia) = $event)),
                                disabled: !_ctx.state.editavel
                              }, null, 8, ["dataSelecionada", "disabled"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo movimento",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_movimento_financeiro, {
                            valor: _ctx.state.movimento.tipoMovimento,
                            "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.movimento.tipoMovimento) = $event)),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Documento",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_documento_financeiro, {
                            codigoSelecionado: _ctx.state.movimento.codigoTipoDocumentoFinanceiro,
                            "onUpdate:codigoSelecionado": [
                              _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.movimento.codigoTipoDocumentoFinanceiro) = $event)),
                              _cache[8] || (_cache[8] = ($event: any) => (_ctx.atualizarTipoDocumentoFinanceiroSelecionado()))
                            ],
                            empresas: [_ctx.state.movimento.codigoEmpresa],
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_form_item, {
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        label: _withCtx(() => [
                          _hoisted_13,
                          _createVNode(_component_a_tooltip, {
                            placement: "top",
                            title: "Informe aqui o número do documento, título ou qualquer outra numeração que você deseje identificar este movimento."
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_icone, {
                                class: "ss-icone-informacao-campo",
                                nome: "informacao-campo"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.movimento.identificadorMovimento) = $event)),
                            disabled: !_ctx.state.editavel
                          }, null, 8, _hoisted_14), [
                            [_vModelText, _ctx.state.movimento.identificadorMovimento]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_a_form_item, {
                        label: "Valor",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            quantidadeCasasDecimais: 2,
                            valor: _ctx.state.movimento.valor,
                            "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.movimento.valor) = $event)),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "DETALHES"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_a_form_item, {
                                label: "Descrição",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.movimento.descricao) = $event)),
                                    placeholder: "Digite aqui detalhes e informações importantes deste movimento",
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, _hoisted_18), [
                                    [_vModelText, _ctx.state.movimento.descricao]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_a_form_item, {
                                label: "Conciliado",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_sim_nao, {
                                    radioButton: true,
                                    valor: _ctx.state.movimento.conciliado,
                                    "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.movimento.conciliado) = $event)),
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_a_form_item, {
                                label: "Influência Saldo",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_sim_nao, {
                                    radioButton: true,
                                    valor: _ctx.state.movimento.influenciaSaldo,
                                    "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.movimento.influenciaSaldo) = $event)),
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["valor", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_a_form_item, {
                                label: "Pessoa",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_pessoa, {
                                    codigoSelecionado: _ctx.state.movimento.codigoPessoa,
                                    "onUpdate:codigoSelecionado": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.movimento.codigoPessoa) = $event)),
                                    empresas: [_ctx.state.movimento.codigoEmpresa],
                                    apresentarRelacoes: true,
                                    disabled: !_ctx.state.editavel,
                                    recursoOrigem: _ctx.telaBase.identificadorRecurso
                                  }, null, 8, ["codigoSelecionado", "empresas", "disabled", "recursoOrigem"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_a_form_item, {
                                label: "Categoria",
                                class: "ss-margin-campos",
                                rules: [{ required: true }]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_categoria_plano_conta, {
                                    codigoSelecionado: _ctx.state.movimento.codigoPlanoContaCategoria,
                                    "onUpdate:codigoSelecionado": [
                                      _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.movimento.codigoPlanoContaCategoria) = $event)),
                                      _cache[16] || (_cache[16] = ($event: any) => (_ctx.obterCentrosCustoContaContabil()))
                                    ],
                                    empresas: [_ctx.state.movimento.codigoEmpresa],
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_a_form_item, {
                                label: "Marcadores",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_marcador_movimento_financeiro, {
                                    marcadoresSelecionados: _ctx.state.marcadores,
                                    "onUpdate:marcadoresSelecionados": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                                    disabled: !_ctx.state.editavel
                                  }, null, 8, ["marcadoresSelecionados", "disabled"])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "OBSERVAÇÕES"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_card, { titulo: " " }, {
                        default: _withCtx(() => [
                          _createVNode(_component_editor_html, {
                            value: _ctx.state.movimento.observacoes,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.movimento.observacoes) = $event)),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["value", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: "CENTRO DE CUSTO"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_skeleton, {
                        loading: _ctx.state.carregandoCentrosCusto
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_movimento_financeiro_centro_custo, {
                            visivel: _ctx.modalBase.computedVisivel,
                            valor: _ctx.state.movimento.valor,
                            codigoRegistro: _ctx.state.movimento.codigo,
                            centrosCusto: _ctx.state.centrosCusto,
                            "onUpdate:centrosCusto": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.centrosCusto) = $event)),
                            editavel: _ctx.state.editavel
                          }, null, 8, ["visivel", "valor", "codigoRegistro", "centrosCusto", "editavel"])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "4",
                    tab: "ANEXOS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_skeleton, {
                        loading: _ctx.state.carregandoAnexos
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_movimento_financeiro_anexo, {
                            empresa: _ctx.state.movimento.codigoEmpresa,
                            codigoMovimentoFinanceiro: _ctx.state.movimento.codigo,
                            anexos: _ctx.state.movimento.anexos,
                            "onUpdate:anexos": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.movimento.anexos) = $event))
                          }, null, 8, ["empresa", "codigoMovimentoFinanceiro", "anexos"])
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  }),
                  (_ctx.servicoMovimentoFinanceiro.verificaSeMovimentoRelacionadoBaixa(_ctx.state.movimento.recursoOrigem))
                    ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                        key: "5",
                        tab: "TÍTULOS BAIXADOS"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, {
                            spinning: _ctx.state.carregandoTitulosBaixados
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_movimento_financeiro_titulos_baixados, {
                                empresa: _ctx.state.movimento.codigoEmpresa,
                                titulos: _ctx.state.titulosBaixados
                              }, null, 8, ["empresa", "titulos"])
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["title", "visible", "wrap-class-name"]))
}